import {createActions} from 'redux-actions'

export const {
    setWidth

} = createActions({
    SET_WIDTH: (width) => ({width}),

})